import { render, staticRenderFns } from "./Inform.vue?vue&type=template&id=929369c8&scoped=true&"
import script from "./Inform.vue?vue&type=script&lang=js&"
export * from "./Inform.vue?vue&type=script&lang=js&"
import style0 from "./Inform.vue?vue&type=style&index=0&id=929369c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929369c8",
  null
  
)

export default component.exports